export const GETWEATHER_LOADING='GETWEATHER_LOADING'
export const GETWEATHER_SUCCESS='GETWEATHER_SUCCESS'
export const GETWEATHER_FAIL='GETWEATHER_FAIL'
